import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSquareX: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconSquareX"><Path fillRule="evenodd" clipRule="evenodd" d="M3 3H21V21H3V3ZM9 7.58579L7.58579 9L10.5858 12L7.58579 15L9 16.4142L12 13.4142L15 16.4142L16.4142 15L13.4142 12L16.4142 9L15 7.58579L12 10.5858L9 7.58579Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSquareX;
